class mPopinImages extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initZooming();
    }

    initZooming() {
        let images = this.querySelectorAll('.zoom');
        for (const image of images) {
            image.addEventListener('click', (e) => { this.zoomImage(e); });
        }
    }

    zoomImage(e) {
        document.dispatchEvent(new CustomEvent('oFullScreenImages:showZoom', {
            detail: {
                imagesContainer: this,
                currentImage: e.currentTarget
            }
        }));
    }
}

customElements.define('m-popin-images', mPopinImages, {
    extends: 'div'
});
